import { render, staticRenderFns } from "./SessionObservations.vue?vue&type=template&id=020d7550&scoped=true"
import script from "./SessionObservations.vue?vue&type=script&lang=js"
export * from "./SessionObservations.vue?vue&type=script&lang=js"
import style0 from "./SessionObservations.vue?vue&type=style&index=0&id=020d7550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020d7550",
  null
  
)

export default component.exports